import React from "react";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import imgBg from "../../Assets/img/Group 2521.svg";
import imgMain from "../../Assets/img/verification_pending.svg";

function PendingVerification() {
  return (
    <div className="PendingVerification innerBody">
      <Header />
      <div className="container content">
        <div className="row">
          <div className="col text-center">
            <img src={imgBg} alt="" className="bg-img pt-5"/>
            <h3 className="title ml-auto mr-auto text-center mt-3 pt-2">
              VERIFICATION PENDING
            </h3>
             <h5> Check your Inbox to verify your Email </h5> 
            <p className="mt-4 col-8 text-center offset-2 text-white">
              Before you start playing, we need to verify your email. Kindly check your inbox and click the verification link, in order to complete the verification process. 
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col text-center mb-4">
            
            <img src={imgMain} className="verification_img" alt="" />
            <img src={imgBg} alt="" className="bg-img img-main pt-1" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PendingVerification;
